// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2y7gM","Open":"SideDrawer_Open__1QcFT","Close":"SideDrawer_Close__2Qhzo","Logo":"SideDrawer_Logo__3uvdA"};